module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_vm._v("The Fifth Column")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he term the ‘Fifth Column’ was not new in 1939, it originated during the Spanish Civil War (1936–39) when Nationalist General Emilio Mola spoke of his four columns of forces advancing on Madrid and a ‘Fifth Column’ of his militant supporters already within the walls who would rise up in support of the attack. The term remained in generally understood parlance and was easily transferred to the integrated spies and collaborators who appeared out of the woodwork to assist the Nazi forces when they invaded European countries in 1939 and 1940.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0001-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The headlines carried by the newspaper vendors on the streets of London say it all on 3 September 1939.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("The problem was the people on Britain’s home front were confronted with mixed messages. On the one hand eye catching posters in offices, transport hubs, public buildings and meeting places, in fact just about anywhere people gathered, warned ‘Careless Talk Costs Lives’, ‘Walls Have Ears – You Never Know Who’s Listening’ and ‘Keep Mum She’s Not So Dumb’. On the other hand British civil authorities, while implying through the poster campaign there must be spies and collaborators anywhere and everywhere, were keen to play down the existence of a Fifth Column to the public to help avoid panics and keep up morale. Those in authority, be they part of the military or civil powers however, were only too aware of the possibility of the existence of a large body of Nazi infiltrators and collaborators that were already spying and committing acts of sabotage in various forms in preparation for the imminent Nazi invasion.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0002-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cover of")]), _vm._v(" Fifth Column "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by John Langdon Davies (1940) one of the dozens of the informative booklets that primed the British people for the new types of warfare that could confront them.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Churchill was absolutely clear on the matter in a lesser known paragraph of his ‘Fight on the Beaches’ speech to the House of Commons on 4 June 1940:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Parliament has given us the powers to put down Fifth Column activities with a strong hand, and we shall use those powers subject to the supervision and correction of the House, without the slightest hesitation until we are satisfied, and more than satisfied, that this malignancy in our midst has been effectively stamped out.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("By 1940 there was a growing a body of literature by both British and international authors that spoke of the reality of the Fifth Column and warned of its methods. Among them was John Baker White’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dover-Nürnberg, Return")]), _vm._v(" (1937) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Fifth Column")]), _vm._v(" (1940) by John Langdon "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Davies. In fact, Davies was the author of numerous booklets that helped to prepare for the dangers of modern warfare and defined the Fifth Columnist succinctly:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("When does a well meaning man become a traitor? …We certainly cannot distinguish between lawful opposition to a national policy and Fifth Columnist treachery simply by assuming that the latter is paid for by the enemy. It is not on the mercenary weakness, but on the ideals of an individual that the success of Fifth Column tactics depend.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An insight into how the Fifth Column was perceived by British intelligence agencies working at the sharp end of counter espionage at the height of invasion scares in 1940 can be gained from the circulated notes from the lecture Fifth Column Activities on Other Countries presented by MI5 officer Major Kenneth Younger:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The term ‘Fifth Column’ originated in the Spanish Civil War and has also been used to describe the minorities in Poland. Denmark, Norway, Holland and Belgium who assisted the German invasion. The term implies more than individual spies and traitors in the population who are willing to assist the enemy.")])]), _vm._v(" "), _c('p', {
    staticClass: "blki"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As all these countries were invaded without declaration of war, the main work of the Fifth Column was performed by German embassies, consulates")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Travel Bureaus and the German Colony generally, against whom no preventive action had been taken before hostilities broke out. In Poland, Holland and Belgium considerable racial and political minorities existed which were openly unpatriotic. In Denmark and Norway the Fifth Column consisted of a smaller number of highly placed people. There is no evidence that Communists assisted the invader in any of these countries.")])]), _vm._v(" "), _c('p', {
    staticClass: "blki"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Poland and Holland the large scale military action was taken mainly by the German Colony and the Dutch NSB. Preparations made by these bodies had not been kept in any way secret before the invasion. Action taken included seizure of key points and aerodromes, sniping and street fighting, issuing false orders and telephone calls. The Fifth Column in Norway had been kept entirely secret. The German Colony seized certain key points, and false orders issued by a few highly placed traitors disorganised the Norwegian defence.")])]), _vm._v(" "), _c('p', {
    staticClass: "blk1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Racial Minorities of Doubtful Loyalty")])])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("1.")]), _vm._v(" Irish: This is the only section likely to take extensive action to assist the Germans.")])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("2.")]), _vm._v(" Scottish and Welsh Nationalist Movements: Some evidence of German penetration, especially among the Welsh.")])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("3.")]), _vm._v(" Germans: None still at large except some women of German nationality or extraction. Might give aid on a small scale to parachutists.")])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("4.")]), _vm._v(" Other Refugees: 10,000 Czechs, 20,000 Dutch and Belgians. Some German agents must be expected, but the vast majority of these refugees may be considered anti-Nazi. British refugees 6,000 to 7,000 returned from the Low Countries, many unable even to speak English.")])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("5.")]), _vm._v(" Italians: Most of the members of the Italian Fascist Party have either left the country or have been arrested.")])]), _vm._v(" "), _c('p', {
    staticClass: "blk1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Political Minorities of Doubtful Loyalty in Great Britain")])])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("1.")]), _vm._v(" British Union: Membership in March 1940 about 8,000. 600 or 700 interned. Half the membership in London. Policy: authoritarian, anti-Semitic, anti-communist, anti-war. Not organised as a military Fifth Column but focus for people of Nazi sympathies. Subversive action so far discovered the work of individual extremists rather than the organisation. Some half dozen cases since the war show that members deliberately collect secret information. No evidence that they have means of transmitting it to the enemy but much of the information would be useless for any other purpose. Suggested method wireless transmission or crews to Lisbon.")])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0004-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BUF leader Sir Oswald Mosley inspects his ‘Blackshirts’ on Royal Mint Street, East London shortly before the clash on Cable Street, 4 October 1936.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0005-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Blackshirt sentries at the door of the BUF ‘Black House’ Headquarters on King’s Road near Sloane Square, Chelsea 1934.")])])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("2.")]), _vm._v(" Other Pro-Nazi Bodies e,g. Nordic League, Imperial Fascist League etc., small in numbers, now believed inactive.")])]), _vm._v(" "), _c('p', {
    staticClass: "blk-list"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "blk-li"
  }, [_vm._v("3.")]), _vm._v(" Communist Party GB Membership 20,000. Provided no breach of the peace is involved any attempt to stifle such agitation by police action would only arouse additional sympathy for the party")])]), _vm._v(" "), _c('p', {
    staticClass: "blk1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Subversive action by individuals more likely than mass action, except possibly by the IRA. Most likely methods: signalling to aircraft, bogus telephone calls, rumours, aid to parachutists, isolated acts of sabotage.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn1",
      "id": "ch1-fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0006-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pre-war leaflet advertising")]), _vm._v(" Action "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the BUF newspaper")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Despite its parallels and links to the Nazis in Germany and its vile anti-Semitic stance The British Union of Fascists with Sir Oswald Mosley at its helm attracted an ever-growing membership of thousands over the years of its existence between its creation in 1932 up to 1939. Using the skills he "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("acquired as a mainstream Labour politician Mosley knew there were large and influential swathes of society whose interests were not being addressed to their satisfaction by Parliament. Mosley had particular success attracting membership and support from land owners and farmers by offering agricultural policies that would appeal to them, especially the abolition of tithes that creamed off a considerable amount of the annual income of those farming lands subject to them.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0007-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The cover of the")]), _vm._v(" Sunday Pictorial "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("makes the arrest of the Blackshirt activists at the Wortham ‘Tithe War’ headline news Sunday 18 February 1934")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("One particularly infamous intervention became known as ‘The Wortham Tithe War’. Author Doreen Wallace and her husband Rowland Rash had decided to make a stand and refused to pay their tithes for Manor Farm at Wortham in Suffolk. In September 1934 the county bailiffs were due to descend on the property to take away livestock to the value of what was owed. Some fifty members of the British Union of Fascists arrived to act as defenders of the farm under the command of their National Political Officer, Richard Plathen. After fortifying the perimeter with barbed wire and obstacles they hoisted their black flag beside the union flag and mounted vigilante patrols to thwart any attempt to remove the livestock. After sixteen days the police had had enough, they shipped in two bus loads of constables, broke the siege and the bailiffs seized the animals, but these events made headline news for the Blackshirts and gained them a lot more supporters from agricultural areas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To give some idea of the scale of the BUF on the eve of the Second World War it staged a ‘Peace Rally’ at Earls Court in July 1939. With a tall rostrum reminiscent of Nazi Party gatherings decked with Union Flags, the militaristic show of processing bands and banners would not have looked out of place at Nuremberg. The sole speaker to address the 30,000 people gathered there was Sir Oswald Mosley.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Women members of the BUF salute Sir Oswald Mosley, the man many of them simply referred to as ‘The Leader’, Westminster, 7 May 1939")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BUF propaganda flyer produced shortly before the outbreak of war in 1939.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Members of the BUF could also be found both as members of and holding office within other organisations such as the newly formed British Legion and the Peace Pledge Union. This latter pacifist organisation may seem an odd choice but then consider the aim of the PPU was to stop wars, sometimes by direct action that would hinder the British war effort. BUF members also maintained friends and collaborator contacts among just about every walk of life and occupation, especially those who could be of use to them in Government offices, the Post Office, the Armed Forces and the police. There are many instances of police raiding and searching the homes and properties of BUF members when the organisation was banned after the outbreak of war. The inhabitants, clearly expecting their arrival, had dressed in full BUF uniform and greeted the officers at the door with a Fascist salute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The BUF maintained strong links with the Nazi Party in Germany right up to the outbreak of war. The main conduit between the two was Rolf Hoffmann of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reichspressedienst")]), _vm._v(" (Nazi Press Bureau) in Hamburg. He was in regular correspondence with leading British Fascist Admiral Barry Domvile and time and again his name is mentioned in the case notes of interned and suspect list members of the BUF who would mention how they wrote to him to obtain Nazi books, photographs of Hitler and leading figures of the Nazi Party. Hoffmann also supplied copies of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("News from Germany")]), _vm._v(" and offered advice on how to circulate copies when it appeared some of the copies he was sending were being intercepted. He also helped arrange British pro-Hitler supporters attend the Nazi Party rallies at Nuremberg and provided the first point of contact for many of those wishing to become naturalised Germans and attain their goal of becoming fully fledged members of the Nazi Party."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn2",
      "id": "ch1-fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Hoffmann openly came to Britain on several occasions through the 1930s visiting principal towns and cities to meet party faithful and recruit a few more to the cause; on a number of occasions he even gave interviews to the press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, all may not be quite what it seemed. Mosley was undoubtedly a passionate, and to many a charismatic, orator. He was respected and even idolised as Leader of the British Union but his wife Lady Diana Mosley was far from a woman in the shadow of her husband. Diana and her unmarried sister Unity Mitford had been regular and popular visitors to Nazi Germany in the 1930s. Diana was a personal friend of Hitler and had acted as the main conduit for communication between her husband and the Führer "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("before the outbreak of war. An MI5 report from 1940 recognised that of the husband and wife it was Lady Diana Mosley who was the greater threat, and concluded:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Diana Mosley, wife of Sir Oswald Mosley, is reported on the best authority, that of her family and intimate circle, to be a public danger at the present time. Is said to be far cleverer and more dangerous than her husband and will stick at nothing to achieve her ambitions. She is wildly ambitious")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn3",
      "id": "ch1-fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But as we shall see later in this book, both the Mosleys could have been shunted to the sidelines if the Nazi invasion had taken place and the Major General John Fuller or Leigh Vaughan Henry plots had been successful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Mosleys and BUF were far from the only people enamoured with Hitler and Nazi ideals and for a while in the mid 1930s public figures who spoke out against the dangers presented by the Nazis faced derision. Among the most vocal was Lord Robert Vansittart who warned of the Nazi aspirations for European domination. His opposition to appeasement saw him derided for having ‘an inflexible mind’ and ‘Vansittartism’ became a byword for a Germanophobia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Nazi regime was keen to win international support and embarked on a charm offensive organising exchange visits between British and German students, military veterans and businessmen. Various Anglo-German groups were established and holidaymakers were encouraged to come and see Germany for themselves. Keen to show their prowess and commitment to sport and healthy activities German competitors were supported by Nazi Party officials whenever they competed at major sporting events in Britain and Europe.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Membership card for the Ipswich Anglo-German Club.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A case in point is The Women’s League of Health and Beauty which had been founded in 1930 by Mrs Mary ‘Mollie’ Bagot-Stack on the simple premise that regular exercise will make the people of Britain healthier and fitter. After Mollie’s death in 1935 her daughter Prunella carried on what her mother had begun, but the tone of the group changed. Prunella had visited Germany and had been much impressed by the Nazi public fitness programme, especially the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bund Deutscher Mädel")]), _vm._v(" (BDM) or League of German Girls, the female wing of the Nazi youth movement. Influenced by what she had seen the public demonstrations of exercise, dance and movement performed my members of the League of Health and Beauty in Britain got bigger, more elaborate and would include thousands of women in uniform outfits all taking part in huge choreographed public performances of graceful but regimented exercise. After film of the Nazi Party rallies and the outdoor gymnastic activities of the girls of the Nazi BDM had been part of the reportage of newsreels shown in British cinemas, it did not take much for both public and press to draw comparisons between the two.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Guests of honour at the Anglo-German Fellowship dinner, 1937. Foreground, left to right, Lord Halifax, Fellowship President Prince Karl Eduard, Duke of Saxe-Coburg and German Ambassador Ribbentrop.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lapel badge worn by members of the Anglo-German Link founded by Admiral Sir Barry Domvile in 1937.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nazi Ambassador Ribbentrop (the ‘von’ was an affectation he assumed and was not entitled to) was described in some newspapers as ‘one of the most popular men in London’ shortly after his appointment. The aggressive behaviour of the Nazis and Ribbentrop’s sycophantic loyalty to the Party line soon showed his true colours and he became a frequent target for")]), _vm._v(" Punch "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("magazine.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("German travel brochure c1937. In the late 1930s the Nazi German charm offensive was on and the people of Britain were urged to come and see for themselves rather than judge Germany by what they heard.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Priscilla also changed the name of the official journal of the League from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mother & Daughter")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Health and Beauty")]), _vm._v(" but in doing so she also revised the core aims of the group to a five point plan which was printed on the inside cover of the journal. Four points spoke of encouraging expression of beauty, fostering success, safer and easier motherhood and the final point in the boldest type ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…to promote the cause of national health, which must lead to RACIAL HEALTH AND PEACE")]), _vm._v(".’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn4",
      "id": "ch1-fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" At a time when the Nazi vision and aim for racial purity, and the Aryan man was extolled by Nazi theorist Alfred Rosenberg and appearing in magazines and newspapers across Europe, many would wonder if The Women’s League of Health and Beauty was indeed a ‘fellow traveller’ of the Nazis.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Reichsfrauenfühererin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gertrud Scholtz-Klink described by Hitler as the ‘perfect Nazi woman’.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Girls of the")]), _vm._v(" Bund Deutscher Mädel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(BDM) or League of German Girls, the female wing of the Nazi youth movement. Note the similarities between their gym kit and that worn by members of The Women’s League of Health and Beauty.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 1938 the aggressive acts of Nazi Germany on the world stage saw Europe drawn to the brink of war. Toleration and appeasement may have been evinced at Munich but earlier in the year the British public were already uncomfortable about the anti-Semitism and militaristic aggression being shown by the Nazis. Coverage of an arena display by the Women’s Health and Beauty in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Express")]), _vm._v(" described the dancers as ‘Stormtroops’ and Prunella Stack as ‘a radiant, strapping, 23-year-old Nordic, with excellent teeth’. They captioned a photograph of her as ‘Führer Stack’ adding that she studied new methods of physical training last year in Berlin and ‘she’s frightfully keen on anything German.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn5",
      "id": "ch1-fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" If anyone was left in any doubt "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reichsfrauenfühererin")]), _vm._v(" Frau Gertrud Scholtz-Klink, the head of the (NS-Frauenschaft) National Socialist Women’s Union, the most senior woman in the Nazi Party in 1939 made a high profile visit to England. She was not only photographed being heartily welcomed at a display arranged by Stack and members of the League of Health and Beauty, but she attended an Anglo-German Fellowship dinner in her honour at Claridges where both Klink and Stack were keynote speakers. After the outbreak of war the League was quite keen to change its image.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The point of this example is that The League of Health and Beauty was just one of a surprising number of organisations and political groups that "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("were very much in sympathy with Nazi ideals. The problem was that some of their members would remain loyal to them even in wartime. There were also many ex-pat Germans and born and bred Britons who were of the opinion that Hitler was truly a great man and some of them would be willing to ‘do their bit’ for their Führer. Any organised group, club or premises associated with Germany in Britain in the late 1930s was perceived as a potential threat and would often be infiltrated by operatives from Special Branch or MI5. Anglo German Clubs were closed down on the outbreak of war. The German Hospital at Dalston also acquired a particular notoriety for the pro-Nazi sympathies of the staff when it was headed by Otto Bode. Guy Liddell, the head of MI5 B Divsion referred to it as ‘A little piece of Nazi Germany in the middle of London,’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn6",
      "id": "ch1-fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" but when it was reliably reported that Nazi salutes were exchanged in its corridors something had to be done and the German staff were replaced with British ones.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gertrud Scholtz-Klink (left) and Prunella Stack, Leader of The Women’s League of Health and Beauty watch a display by members of the League staged for Klink’s official visit to Britain in March 1939.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("The Nazis never played fair. The good will visits were merely a veneer to cover an operative amongst the group of visiting Germans whose specific remit would be information gathering for espionage purposes. Groups of Hitler Youth on exchange visits taken to see industrial sites and transport hubs would also have been unwittingly taking photographs, gathering maps and business prospectuses that would be of future use to German intelligence. Nazi agents had been operating in Britain since before the Nazi Party obtained power. The Germany Embassy staff and its attachés were all Nazi Party members by the late 1930s. Several of them were exposed for their involvement as recruiters of British people to engage in spying or letter smuggling for the Reich for money. Some of the diplomatic staff and attachés were asked to leave the country when their activities were exposed, others fled by 1 September 1939.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is not generally realised that the Nazi Party had an overseas branch or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Auslands-Organisation")]), _vm._v(" in Britain. The leader of this organisation was Ernst Bohle who had been born in Bradford, Yorkshire in 1903 to German parents, who had then moved as a family to South Africa in 1906. Returning to Germany as a young man, he was educated in Cologne and Berlin. Bohle became an early member of the Nazi Party and was appointed Gauleiter of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Auslands-Organisation")]), _vm._v(" in 1934.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Miss Unity Mitford and her sister Lady Diana Mosley with SS Troops at the Nazi Party Rally, Nuremburg 1937.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nurses from The German Hospital, Dalston photographed in a train carriage in April 1938. Suspicion fell on the staff of the hospital being Nazi sympathisers and reports were received of Nazi salutes being given regularly in its corridors.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In August 1937 Winston Churchill published an eloquent but critical article in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evening Standard")]), _vm._v(" titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Plain Word to the Nazis")]), _vm._v(" in which he raised his concerns about the Nazis and called on Parliament to increase scrutiny and surveillance of Germans living in Britain and to deport them if necessary. The article certainly stirred up the Nazi overseas organisation and Bohle wrote to Churchill’s literary agent Emery Reves wishing to discuss the article with its author. The message was duly forwarded and Churchill welcomed the opportunity, stating in his subsequent article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friendship with Germany")]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I see Herr Bohle has expressed a wish to talk this over with me. I should be delighted to do so in the most friendly manner, and do anything in the power of a private member to remove this new embarrassment to Anglo-German goodwill.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn7",
      "id": "ch1-fn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Winston Churchill and Ernst Bohle, Leader of the Nazi")]), _vm._v(" Auslands-Organisation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in Britain, after their meeting at Churchill’s London residence on 1 October 1937.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The pair met at Churchill’s London residence on 1 October 1937. Bohle would recall the meeting lasted more than an hour adding:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I had ample opportunity in this thoroughly cordial conversation to describe the activity of the Auslands-Organisation and to dispel his misgivings. At the end he accompanied me to my car and let himself be photographed with me, in order, as he said, to show the world that we were parting as friends")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn8",
      "id": "ch1-fn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Restaurant Manager Emilio Rossi’s Membership card for the London Branch of Mussolini’s")]), _vm._v(" Partito Nazionale Fascista"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(", (National Fascist Party). Every card carried the pledge of the member ‘")]), _vm._v(" to carry out the orders of the Duce and to serve with all my strength and, if necessary, with my blood, the cause of the Fascist Revolution"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".’")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cordial as the meeting may have been Churchill would not be photographed shaking hands with Bohle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the time Churchill wrote his article and met with Bohle he was out of office and, being out of favour in political circles, could do very little more than bring attention to the machinations of the Nazis in Britain in his articles. Both MI5 and Special Branch "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("were only too aware if the nefarious espionage activities of the Nazis in Britain, notably that Nazi security services were spying on their own German nationals abroad. Nazi intelligence officials were also not above using coercive methods to get German nationals to spy on other German nationals or use them for the purposes of espionage, but that was not enough. Nazi German authorities issued a decree on 3 February 1938 requiring all German citizens who had been abroad for more than three months to register with their nearest German consulate. Once registered each person would be expected to keep the consulate updated of any subsequent change of address. It was the responsibility of the heads of households to ensure all those residing with them were registered, failure to do so could result in a fine of up to 500RM.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cover of")]), _vm._v(" The German Octopus "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Lord Robert Vansittart (1945). His warnings of the dangers presented by the Nazis, their aspirations for European domination and his opposition to appeasement in the 1930s saw him derided for having ‘an inflexible mind’ and Vansittartism became a byword for Germanophobia.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anyone who knowingly or persistently failed to register would be declared to have lost their German nationality."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn9",
      "id": "ch1-fn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The official reason given was that this act would unite German nationals abroad and maintain their relationship "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("with the Fatherland, but few were under any illusions, the act was created to enable the Nazis to impose tighter regime controls over Germans living abroad. With fear and coercion, threats of reprisals against family members, seizure of money or property back in Germany all at their disposal, this decree gave Nazi authorities the ability, at will, to apply pressure on any German national abroad to spy on neighbours and/or spy for the Reich. British intelligence was under no illusions that this could potentially create the greatest spy network of all time and it would be at the disposal of the Nazis.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A wide variety of posters warning of the dangers of ‘careless talk’ were displayed inside and outside offices, public buildings, places of entertainment, at transport hubs and on our streets during the war years.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When war loomed the Home Office and security services wanted every Nazi out of the country. Guy Liddell noted on 1 September 1939:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Telegrams for the arrest of German Party members of German suspects in Category I were sent out at 1.30pm. The telegrams for the arrest of persons under Section 18B were sent out between 3.30 and 4.30pm")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It had also been agreed by all concerned parties that:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("…nobody on our lists of Party members or suspects should be stopped at the ports unless we had very special reasons for holding them.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But still Nazis that were not known to the security services, BUF members and their sympathisers remained at large. As the months passed by, the blitzkrieg unleashed on the Low Countries, Belgium and France knocked allied forces onto the back heel in May 1940 and some of these traitorous individuals gathered at clandestine meetings and drew up their plans to aid the invading Germans to bring about the downfall of Britain.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0022-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The War Weekly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of 24 May 1940 graphically warns of the paratroop menace that was reportedly used to devastating effect during the German invasion of the Low Countries.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("German occupation troops photographed on the street near The Panthéon, Paris 1940. In the aftermath of German forces invading their european neighbours numerous images were published in various newspapers showing German troops with individuals in civilian clothes the press were quick to not only brand as collaborators but ‘Fifth Columnists’.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("During the invasion scares of 1940 British newspapers and magazines carried various tips on how to spot and foil ‘Fifth Columnists’.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0023-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A wry comment by the cartoonist Lawrence Siggs on the numerous false alarms over spotting parachute troops,")]), _vm._v(" Punch "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("11 September 1940.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("One of the most ambitious plans for an armed rising by those who could easily be branded ‘Fifth Columnists’ was revealed by Tim Tate in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hitler’s British Traitors.")]), _vm._v(" It was devised by composer, conductor and expert on the Welsh bardic tradition Dr Leigh Vaughan Henry, a man who was also a rabid pro-Nazi and anti-Semite. Henry and his confederates apparently raised eighteen ‘cells’ of twenty-five terrorists across London in preparation for an armed coup to pave the way for the German invasion forces landing in Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What Henry did not realise was he had already been infiltrated by two MI5 moles and as Henry began to ramp up his plans he openly shared them with those he thought he could trust. His ideas were very similar to those of Quisling in Norway and on 10 May 1940 Henry’s house was raided. The whole sordid story that unfolded was told in the report of Inspector Arthur Cain of Special Branch who executed the warrant:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In London Vaughan Henry has organised district ‘cells’ under ‘sergeants’ who use code terms and keep in touch with him by telephone. He claims that when all the Government defence authorities in England have been disorganised, his group would come on the streets and assume control.")])]), _vm._v(" "), _c('p', {
    staticClass: "blki"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Amongst the documents was a code, which [Henry] stated he had devised for communicating with his wife in Germany. There are also draft plans for a subversive organisation to establish an authoritarian system of Government.")])]), _vm._v(" "), _c('p', {
    staticClass: "blki"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The methods to be adopted include illegal printing, a transport section to convey the members in their various activities, an extensive arrangement of accommodation addresses and various aliases for leading members of the organisation. Among Dr Henry’s chief associates in these political activities have been Captain Ramsay MP, Jock Houston, Samuel F. Darwin Fox and Norman Hay.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn10",
      "id": "ch1-fn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There was also evidence of serious negotiations for the purchase of weaponry and munitions to arm the group."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn11",
      "id": "ch1-fn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Vaughan Henry was arrested and would spend the rest of the war interned on the Isle of Man, others would hang for far less under the Treachery Act. Tate suggests a possible reason for his escape from the gallows or even a trial was that Henry’s plot included such senior figures from Britain’s political and military establishments they could not risk a trial, even in camera, for fear of some or all the names leaking out and becoming known to the public. It could also be argued MI5 would not have wanted to risk the loss of valuable undercover agents who helped to uncover the plot through exposure. The chances are we will never know the truth because the files that name those involved or the exchanges of opinion between MI5 and DPP don’t appear to exist any more."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn12",
      "id": "ch1-fn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0025-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("General Edmund Ironside, Commander-in-Chief Home Forces, 1940. One of many senior British armed forces officers convinced of the existence and danger presented by the ‘Fifth Column’ in Britain.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another case had also blown up involving Tyler Kent a young employee of the American Embassy who had been caught passing sensitive diplomatic documents to Anna Wolkoff, a known associate of William Joyce the Nazi propaganda broadcaster known as Lord Haw-Haw. Wolkoff also had contacts with access to send diplomatic bags to the continent. She was also known to be part of the ‘inner circle’ of The Right Club which included Archibald Ramsay its vitrioloic anti-Semite leader. As far as Churchill was concerned enough was enough, something drastic had to be done to cut all those who could potentially rise up as a Fifth Column, regardless of the fall out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A meeting was arranged with Home Secretary Sir John Anderson at the Home Office on the evening of 21 May. The reason for inaction soon emerged, Anderson had formed the opinion that the BUF was in reality patriotic and he found it difficult to believe that members of the BUF would assist the enemy. Despite some of the underground activities of the BUF, Maule Ramsay and The Right Club, and their close association with Moseley and the BUF being explained to him ‘quietly and forcibly’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn13",
      "id": "ch1-fn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" by Max Knight, Anderson appeared unmoved, even when Guy Liddell stressed the urgency of the matter Anderson still expressed his concerns over sanctioning the arrests without solid evidence and due process. Clearly, frustrated by the Home Secretary’s stance, Liddell recorded in his diary:")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Detectives arresting a member of the London headquarters staff of the British Union of Fascists, 24 May 1940.")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0026-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Women ‘enemy aliens’ leaving under police escort from a London station for detention camps on the Isle of Man, May 1940.")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "blk"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I longed to say that if somebody did not get a move on there would be no democracy, no England and no Empire and that this was almost a matter of days…Either he is an extremely calm and cool-headed person or he has not the least idea of the present situation. The possibility of a serious invasion of this country would seem to be no more than a vague suggestion in Anderson’s mind.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn14",
      "id": "ch1-fn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Anderson was however, at least in Liddell’s opinion, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("considerably shaken by the end of the meeting’")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Notes#rch1-fn15",
      "id": "ch1-fn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" and asked for further evidence of a number of the points brought to his attention for the Cabinet meeting the following night. The meeting and the evidence clearly made an impression on Anderson and the Cabinet decided in favour of the detention of many members of pro-Nazi groups, predominantly members of the British Union of Fascists; a suitable amendment known as 18B (1A) was made to the regulations and the arrests ensued soon afterwards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Internments under 18B were further extended on 27 May to include ‘enemy alien’ women who were also to be interned. A concession was made that permitted them to take their children with them. When Italy declared war on Britain on 10 June 1940 Churchill was in no mood for procrastination and it is said he simply barked ‘Collar the lot!’ and the 4,000 known members of the Italian Fascist Party resident in Britain were arrested and interned along with Italians aged between sixteen and thirty who had lived in the UK for less than twenty years, regardless of their political affiliations.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("German map from a 1940 propaganda publication showing a stylised plan for the conquest of Britain.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec02c88e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 78
// module chunks = 0